export default function ({ store }) {
  console.log('찜 초기화 플러그인 실행')

  // 로그인 상태 확인 후 찜 목록 로드
  const checkAndLoadZzim = () => {
    const mbMngNo = store.getters['session/getMbMngNo']
    if (mbMngNo && mbMngNo !== 'undefined' && mbMngNo !== '') {
      store.dispatch('zzim/fetchZzimList')
    } else {
      console.log('로그인되지 않아 찜 목록 로드 건너뜀')
    }
  }

  // 초기 로드
  checkAndLoadZzim()

  // 포커스 시 갱신
  window.addEventListener('focus', checkAndLoadZzim)

  // mbMngNo 변경 감지 (로그인/로그아웃)
  store.watch(
    state => state.session.member.mbMngNo,
    (newMbMngNo, oldMbMngNo) => {
      if (newMbMngNo !== oldMbMngNo) {
        console.log('mbMngNo 변경 감지, 찜 목록 갱신/초기화')
        store.dispatch('zzim/fetchZzimList')
      }
    }
  )
}
